
import { Getter } from 'vuex-class';
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import moment from 'moment';

@Component({
  components: {
    ChevronRight: () => import('@/assets/svg/chevron-right.svg'),
    IconCloud: () => import('@/assets/svg/cloud.svg'),
    ElAvatar: () => import('@/components/parts/ElAvatar.vue'),
    Dashboard: () => import('@/assets/svg/dashboard.svg'),
    News: () => import('@/assets/svg/news.svg'),
    Timeline: () => import('@/assets/svg/timeline.svg'),
    PhasingOutPlan: () => import('@/assets/svg/phasing-out-plan.svg'),
    Chat: () => import('@/assets/svg/chat.svg'),
  },
})
export default class PageDashboard extends Vue {
  @Getter('user/current') user: User | undefined;
  @Getter('user/auth') auth!: Auth;

  @Prop({ default: false }) canGoBack!: boolean;

  @Prop({ default: false }) mobileDragRefresh!: boolean;

  $refs!: {
    floating: HTMLElement;
  };

  top: number = 0;

  mounted() {
    this.$nextTick(() => {
      const floating: HTMLElement | undefined = this.$refs.floating;
      if (floating) {
        const width: number = floating.clientWidth;
        floating.style.width = `${width}px`;
        floating.style.position = `fixed`;
      }
    });
    if (this.auth) {
      this.$i18n.locale = this.auth.locale;
      moment.locale(this.auth.locale);
    }
  }

  get hasBannerSlot() {
    return !!this.$slots.banner;
  }

  @Emit('on-scroll')
  private handleOnScroll(top: number) {
    this.top = top;
    return top;
  }

  @Emit('on-refresh')
  private handleOnRefresh(done: () => void) {
    return done();
  }

  @Emit('on-load-more')
  private handleLoadMore(done: (noMore: boolean) => void) {
    return done;
  }
}
